
import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Select,
    Button,
    Typography,
    Alert
} from '../../ui/ot'
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react"

const OverdueChangeForm = ({
    keyPrefix = "library.backstage.overdue_processing",
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {}
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };

    const setFieldValue = (name, value) => {
        form.setValue(name, value);
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);


    useEffect(() => {
        // (propsForm ?? form).setFieldsValue({ ...defaultValue })
        setCount((pre) => pre + 1)
    }, [])

    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                // initialValues={initialValues}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={setFieldValue}
                                setCount={setCount}

                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    keyPrefix = "library.backstage.overdue_processing",
    field,
    initialValues = {},
    show,
    getAnyFormValue,
    count,
    setFieldValue,
    setCount
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    return (
        <>
            <Row gutter={[8,8]}>
                <Col span={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'issue_id']}
                        fieldKey={[field?.fieldKey, 'issue_id']}
                        hidden={true}
                    >
                        <div></div>
                    </Form.Item>

                </Col>
                <Col span={24}>
                    <Typography.Title level={4}>
                        書名：{getAnyFormValue('bib_title')}{getAnyFormValue('bib_subtitle')} 
                    </Typography.Title>
                    <Typography.P >
                        借閱人：{getAnyFormValue('staff_name')} 
                    </Typography.P>
                </Col>
                <Col span={24}>
                    <Alert 
                    type={"info"}
                     message={"權限警告"} 
                     description={'變更到期日需要管理員權限。此操作將被記錄在系統日誌中。'}
                     icon ={<AlertTriangle />}
                     showIcon ={true}
                    />
                </Col>
                <Col span={24}>
                    <Form.Item
                        label={"選擇新的到期日"}
                        {...field}
                        name={[field?.name ?? '', 'issue_date_due']}
                        fieldKey={[field?.fieldKey, 'issue_date_due']}
                        rules={[
                            {
                                required: true,
                                message: "請輸入",
                            },

                        ]}
                    >
                        <Input type="date" />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};





export default OverdueChangeForm;
